import React, { useState } from "react";
import { getAuthHeaders } from "../../misc";
import { Card, CardBody, CardHeader } from "../card/card.jsx";

const ThumbnailUploader = ({ songReelId, thumbnail, setThumbnail }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("thumbnail", file);

    setUploading(true);
    setError("");

    try {
      const response = await fetch("https://api.moatoverflow.com/v1/song_reel/upload/song-thumbnail", {
        method: "POST",
        headers: { ...getAuthHeaders() },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        setThumbnail(data.thumbnail);
        // Optionally save thumbnail in document
        if (songReelId) {
          await fetch(`https://api.moatoverflow.com/v1/song_reel/${songReelId}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              ...getAuthHeaders(),
            },
            body: JSON.stringify({ thumbnail: data.thumbnail }),
          });
        }
      } else {
        setError("Upload failed.");
      }
    } catch (err) {
      console.error("Upload error:", err);
      setError("Error uploading thumbnail.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Card className="thumbnail-uploader mb-3">
        <CardHeader><h5>Upload Thumbnail</h5></CardHeader>
        <CardBody>
            <label className="form-label">Upload Custom Thumbnail</label>
            <input type="file" accept="image/*" onChange={handleFileChange} className="form-control" />
            {uploading && <p>Uploading...</p>}
            {error && <p className="text-danger">{error}</p>}
            {thumbnail && (
                <div className="mt-2">
                <p>Preview:</p>
                <img
                    src={`https://api.moatoverflow.com/images/${thumbnail}`}
                    alt="Thumbnail Preview"
                    style={{ maxWidth: "300px", borderRadius: "8px" }}
                />
                </div>
            )}
        </CardBody>
    </Card>
  );
};

export default ThumbnailUploader;
